if (!customElements.get('esc-hero-rotator')) {
  class EscHeroRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.esc-hero__slide'));
      if (this.slides.length < 2) return;

      this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // theme editor: show the block an admin selects, resume on deselect
      this.onBlockSelect = (event) => {
        const i = this.slides.indexOf(event.target);
        if (i >= 0) {
          this.stop();
          this.show(i);
        }
      };
      this.onBlockDeselect = (event) => {
        if (this.slides.includes(event.target)) this.start();
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    show(i) {
      this.slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === i);
        if (idx === i) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      this.index = i;
    }

    next() {
      this.show((this.index + 1) % this.slides.length);
      this.queueNext();
    }

    // each slide carries its own duration, so the next transition is
    // scheduled from the slide that just became active rather than a
    // single fixed interval for the whole rotator
    queueNext() {
      const current = this.slides[this.index];
      const durationMs = (parseFloat(current.dataset.duration) || 6) * 1000;
      this.timer = setTimeout(() => this.next(), durationMs);
    }

    start() {
      if (this.reducedMotion.matches) return;
      this.stop();
      this.queueNext();
    }

    stop() {
      clearTimeout(this.timer);
    }
  }

  customElements.define('esc-hero-rotator', EscHeroRotator);
}
